<template>
  <div class="col-lg-12">
    <div class="col-lg-6 form-group">
      <label>Дата создания</label>
      <p class="form-control-static">
        {{ createDate }}
      </p>
    </div>
    <div class="col-lg-6 form-group" v-if="updateDate">
      <label>Дата последнего обновления</label>
      <p class="form-control-static">
        {{ updateDate }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    createDate: {
      type: String,
      required: true,
    },
    updateDate: {
      type: String,
      default: null,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/_shared/features/form/Dates.vue